import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContextDebugComponent  } from './context-debug.component';
import {MatToolbarModule} from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
  declarations: [ContextDebugComponent    
  ],
  imports: [
    CommonModule, 
    MatToolbarModule,
    MatIconModule   
  ],
  entryComponents:[ContextDebugComponent],
  bootstrap:[ContextDebugComponent]  
})
export class ContextDebugModule { }

